import { useNavigator } from '@repo/toolkit/use-navigator'
import { InstructionIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getTripBookingGuideline } from '../../api/trip-booking-guidelines/get-trip-booking-guideline'
import { updateTripBookingGuideline } from '../../api/trip-booking-guidelines/update-trip-booking-guideline'
import { ItemNotFound } from '../../components/elements/item-not-found'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import TripBookingGuidlineForm from '../../components/pages/trip-booking-guidelines/trip-booking-guideline-form'
import { mapTripBookingGuidelineToInput } from '../../components/pages/trip-booking-guidelines/utils'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'
import NotFoundPage from '../common/not-found'

const TripBookingGuidelineUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de consigne invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updateTripBookingGuideline,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['trip-booking-guidelines', id] })
      toast.success('Consigne modifiée avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['trip-booking-guidelines', id],
    queryFn: () => getTripBookingGuideline(+id)
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={'Modifier la consigne'} icon={InstructionIcon} />
      <div className={'h-4'} />
      <TripBookingGuidlineForm
        defaultValues={mapTripBookingGuidelineToInput(data)}
        buttonsConfig={updateButtonsConfig({
          onCancel: () => back(Paths.TRIP_BOOKING_GUIDELINE_LIST_PAGE),
          onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
          onUpdateThenCreate: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.TRIP_BOOKING_GUIDELINE_CREATE_PAGE)
          },
          onUpdateThenList: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.TRIP_BOOKING_GUIDELINE_LIST_PAGE, { replace: true })
          }
        })}
      />
    </div>
  )
}
export default TripBookingGuidelineUpdatePage
